import { ISigner } from '../../types/Parties';

export enum SignerType {
  ConnectBorrower = 'buyer/borrower',
  SolexBorrower = 'borrower',
  Seller = 'seller',
  ConnectNPE = 'nbs',
  SolexNPE = 'npe',
  PowerOfAttorney = 'poa',
  Witness = 'witness',
  Lender = 'lender',
}

export const signerTypeDisplayStrings: {
  -readonly [key in SignerType]: string;
} = {
  [SignerType.ConnectBorrower]: 'Buyer/Borrower',
  [SignerType.SolexBorrower]: 'Borrower',
  [SignerType.Seller]: 'Seller',
  [SignerType.ConnectNPE]: 'NBS',
  [SignerType.SolexNPE]: 'NPE',
  [SignerType.PowerOfAttorney]: 'POA',
  [SignerType.Witness]: 'Witness',
  [SignerType.Lender]: 'Lender',
};

export const isSignerOfType = (
  signer: ISigner,
  targetType: SignerType
): boolean => {
  const connectType = signer.SignerType?.toLowerCase();
  const solexType = signer.SolexSigner?.SignerType?.toLowerCase();

  return connectType === targetType || solexType === targetType;
};

export const isBorrower = (signer: ISigner): boolean =>
  isSignerOfType(signer, SignerType.ConnectBorrower) ||
  isSignerOfType(signer, SignerType.SolexBorrower) ||
  isSignerOfType(signer, SignerType.Seller);

export const isNPE = (signer: ISigner): boolean =>
  isSignerOfType(signer, SignerType.ConnectNPE) ||
  isSignerOfType(signer, SignerType.SolexNPE);

export const bySignerType = (): ((
  first: ISigner,
  second: ISigner
) => number) => {
  return (first: ISigner, second: ISigner) => {
    const firstSignerTypeRank =
      signerTypeOrderingRanks[first.SignerType?.toLowerCase() as SignerType];
    const secondSignerTypeRank =
      signerTypeOrderingRanks[second.SignerType?.toLowerCase() as SignerType];

    return firstSignerTypeRank - secondSignerTypeRank;
  };
};

const signerTypeOrderingRanks: { -readonly [key in SignerType]: number } = {
  [SignerType.ConnectBorrower]: 1,
  [SignerType.SolexBorrower]: 1,
  [SignerType.Seller]: 1,
  [SignerType.ConnectNPE]: 2,
  [SignerType.SolexNPE]: 2,
  [SignerType.PowerOfAttorney]: 3,
  [SignerType.Witness]: 4,
  [SignerType.Lender]: 5,
};
